import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductContents } from './components/ProductContents';
import { CostComparison } from './components/CostComparison';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '955936987240470';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      w.fbq('init', META_PIXEL_ID);
    }
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-brand-text selection:bg-brand-violetLight/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <AnnouncementBar data-id="element-3" />
      <StickyHeader data-id="element-4" />
      <Hero data-id="element-5" />
      <Testimonials data-id="element-6" />
      <PainPoints data-id="element-7" />
      <ProductContents data-id="element-8" />
      <CostComparison data-id="element-9" />
      <Pricing data-id="element-10" />
      <FAQ data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}